/**
 * ui 组件工厂，所有需要用到的组件可在此注册
 * element-plus 组件库组件注册
 * 自定义组件注册
 */
// import { use } from 'element-plus/es/locale/index';
// import zhcn from 'dayjs/locale/zh-cn';
// import './assets/styles/theme/element-variables.scss';
// import './assets/styles/theme/var.css'
// import globalComponents from '@/components/global-component'; // 自定义组件
// import directives from '@/directives'; // 自定义指令

// import 'element-plus/dist/index.css';
// import zhCn from 'element-plus/es/locale/lang/zh-cn';

import {
    ElConfigProvider,
    ElAffix,
    // ElAlert,
    ElAside,
    ElImageViewer,
    // ElAutocomplete,
    // ElAvatar,
    ElBacktop,
    ElBadge,
    ElBreadcrumb,
    ElBreadcrumbItem,
    ElButton,
    // ElButtonGroup,
    // ElCalendar,
    ElCard,
    ElCarousel,
    ElCarouselItem,
    ElCascader,
    ElCascaderPanel,
    ElCheckbox,
    // ElCheckboxButton,
    ElCheckboxGroup,
    ElCol,
    // ElCollapse,
    // ElCollapseItem,
    // ElCollapseTransition,
    ElColorPicker,
    ElContainer,
    ElDatePicker,
    ElDialog,
    ElDivider,
    ElDrawer,
    ElDropdown,
    ElDropdownItem,
    ElDropdownMenu,
    ElDescriptions,
    ElEmpty,
    // ElFooter,
    ElForm,
    ElFormItem,
    ElHeader,
    ElIcon,
    ElImage,
    ElInput,
    ElInputNumber,
    ElLink,
    ElMain,
    ElMenu,
    ElMenuItem,
    // ElMenuItemGroup,
    ElOption,
    // ElOptionGroup,
    // ElPageHeader,
    ElPagination,
    // ElPopconfirm,
    ElPopover,
    // ElPopper,
    ElProgress,
    ElRadio,
    ElRadioButton,
    ElRadioGroup,
    ElRate,
    ElResult,
    ElRow,
    // ElScrollbar,
    ElSelect,
    // ElSlider,
    // ElStep,
    // ElSteps,
    ElSubMenu,
    ElSwitch,
    ElTabPane,
    ElTable,
    ElTableColumn,
    ElTabs,
    ElTag,
    ElTimePicker,
    // ElTimeSelect,
    ElTimeline,
    ElTimelineItem,
    ElTooltip,
    // ElTransfer,
    ElTree,
    ElUpload,
    ElInfiniteScroll,
    ElLoading,
    ElMessage,
    ElMessageBox,
    // ElNotification,
    // ElementPlus
} from 'element-plus';
import { CaretTop, CaretBottom } from '@element-plus/icons-vue';

import { Material, Uploader } from '@yanxiu/material';
import { ImgCropper } from '@yanxiu/img-cropper';
import Storage from '@/lib/storage';
import { getApiPrefixV2, getSuperBrandApi } from '@/dao/request-tools';
import { h } from 'vue';
import { checkIsSuperBrand } from './lib/tools';

const cookies = new Storage('cookie');

let apiHost = process.env.VUE_APP_API || getApiPrefixV2();
if (checkIsSuperBrand()) {
    apiHost = getSuperBrandApi()
}
const requestConfig = {
    apiHost,
    accessToken: cookies.getItem('X-DT-accessToken') || cookies.getItem('super-wand-X-DT-accessToken') || '',
    clientId: 'sanren-teacher-pc',
};

function withRequestConfig(WrappedComponent) {
    return {
        render() {
            return h(
                WrappedComponent,
                {
                    'request-config': requestConfig,
                },
                {
                    ...this.$slots,
                },
            );
        },
    };
}

const components = [
    ElConfigProvider,
    CaretTop,
    CaretBottom,
    ElAffix,
    // ElAlert,
    ElAside,
    ElImageViewer,
    // ElAutocomplete,
    // ElAvatar,
    ElBacktop,
    ElBadge,
    ElBreadcrumb,
    ElBreadcrumbItem,
    ElButton,
    // ElButtonGroup,
    // ElCalendar,
    ElCard,
    ElCarousel,
    ElCarouselItem,
    ElCascader,
    ElCascaderPanel,
    ElCheckbox,
    // ElCheckboxButton,
    ElCheckboxGroup,
    ElCol,
    // ElCollapse,
    // ElCollapseItem,
    // ElCollapseTransition,
    ElColorPicker,
    ElContainer,
    ElDatePicker,
    ElDialog,
    ElDivider,
    ElDrawer,
    ElDropdown,
    ElDropdownItem,
    ElDropdownMenu,
    ElDescriptions,
    ElEmpty,
    // ElFooter,
    ElForm,
    ElFormItem,
    ElHeader,
    ElIcon,
    ElImage,
    ElInput,
    ElInputNumber,
    ElLink,
    ElMain,
    ElMenu,
    ElMenuItem,
    // ElMenuItemGroup,
    ElOption,
    // ElOptionGroup,
    // ElPageHeader,
    ElPagination,
    // ElPopconfirm,
    ElPopover,
    // ElPopper,
    ElProgress,
    ElRadio,
    ElRadioButton,
    ElRadioGroup,
    ElRate,
    ElRow,
    ElResult,
    // ElScrollbar,
    ElSelect,
    // ElSlider,
    // ElStep,
    // ElSteps,
    ElSubMenu,
    ElSwitch,
    ElTabPane,
    ElTable,
    ElTableColumn,
    ElTabs,
    ElTag,
    ElTimePicker,
    // ElTimeSelect,
    ElTimeline,
    ElTimelineItem,
    ElTooltip,
    // ElTransfer,
    ElTree,
    ElUpload,
    ElMessage,
    // ...globalComponents
];

const plugins = [
    ElInfiniteScroll,
    ElLoading,
    // ElMessage, // 不起作用
    ElMessageBox,
    // ElNotification,
];

/**
 * 自主开发的组件
 */
// const personalComponents = [
//     MaterialDialog
// ];

/**
 * 自主开发的插件
 */
const personalPlugins = [];

export default {
    /**
     * 注册按需引入使用到的组件
     * @param {object} app vue的createApp 实例
     */
    register(app) {
        // 设置语言
        // use(zhcn);

        // 组件库注册
        components.forEach(component => {
            app.component(component.name, component);
        });
        plugins.forEach(plugin => {
            app.use(plugin);
        });
        // app.use(ElementPlus, {
        //     local: zhCn
        // })

        // 自定义注件
        app.component('material-dialog', withRequestConfig(Material));
        app.component('img-cropper', withRequestConfig(ImgCropper));
        app.component('Uploader', withRequestConfig(Uploader));

        // personalComponents.forEach(component => {
        //     app.component(component.name, component)
        // });
        // personalPlugins.forEach(plugin => {
        //     app.use(plugin)
        // });

        // 注册directive
        // for (let key in directives) {
        //     app.directive(key, (el, binding)=>{
        //         directives[key](el, binding);
        //     })
        // }
        return app;
    },
};
